import React, { useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import Select from 'react-select';
import clsx from 'clsx';
import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'

import { useProfileState } from 'context/profile'

const SignatureTypeOption = ({ innerRef, innerProps, ...rest }) => {
    const { data, isSelected } = rest;

    const styles = data.locked ? {
        pointerEvents: 'none',
        color: '#aaa'
    } : {}

    return (
        <div 
            className={clsx(
                'd-flex flex-column px-3 py-1 juridistion-select--option', 
                isSelected && 'active', 
                data.locked && 'disabled'
            )} 
            ref={innerRef} 
            style={styles}
            {...innerProps}
        >
            <div className="align-items-center">
                <img className="signature-icon" src={`/images/listing/${data.value}.png`} style={{width: 30}} alt={data.description} />
                <strong className="ml-2">{data.label}</strong>
            </div>
            <small>{data.description}</small>
            {/* <components.Option {...props} /> */}
        </div>
    );
}

export function useSignatureTypeList({ isPdf = false }) {
    const { t } = useTranslation();
    const { profile } = useProfileState()
   

    const { isFadLocked, isFielLocked } = useMemo(() => {
        const fadCount = profile?.tenant?.limits?.fadSignatures ?? 0; 
        const fielCount = profile?.tenant?.limits?.availableFiels ?? 0; 

        return { isFadLocked:  fadCount <= 0, isFielLocked: fielCount <= 0 }
    }, [profile.tenant])


    const signatureTypesMap = useMemo(() => {
        const map = new Map([
          ['none', {
            label: t('editor.config.signature_none'),
            value: 'none',
            description: t('editor.config.signature_none_description'),
          }],
          ['autograph', {
            label: t('editor.config.signature_autograph'),
            value: 'autograph',
            description: t('editor.config.signature_autograph_description'),
          }],
          ['certificate', {
            label: t('editor.config.signature_certificate'),
            value: 'certificate',
            description: t('editor.config.signature_certificate_description'),
            locked: isFielLocked // || !profile.planCan('CREATE_SIGNATURE_CERTIFICATE') 
          }],
        ])

        // if (isPdf) {
        //     map.set('fad', {
        //         label: t('editor.config.signature_FAD'),
        //         value: 'fad',
        //         description: t('editor.config.signature_fad_description'),
        //         locked: isFadLocked
        //     })
        // }
        return map;
    }, [t, isFielLocked])
    
    return { signatureTypesMap, signatureTypesArray: Array.from(signatureTypesMap.values()) }
}

export function SignatureTypesSelect({ isPdf, value, onChange, ...props }) {
    const [realValue, setRealValue] = useState(null);
    const { signatureTypesArray, signatureTypesMap } = useSignatureTypeList({ isPdf });

    useEffect(() => {
        if (signatureTypesMap.get(value)) {
            setRealValue(signatureTypesMap.get(value))
        } else {
            setRealValue(null)
        }
    }, [signatureTypesMap, value])

    const handleChange = (option) => {
        onChange(option?.value || null, option)
    }

    return <Select 
        components={{ Option:  SignatureTypeOption }}
        options={signatureTypesArray}
        styles={reactSelectStyles}
        value={realValue}
        onChange={handleChange}
        {...props}
    />
}